import React from "react";
import { Avatar, useTheme } from "@mui/material";
import { MeSchema } from "../../api/schemas/responses/users";
import Tooltip from "@mui/material/Tooltip";

interface MainAvatarProps {
    user: MeSchema | undefined;
    size?: number;
}

export default function MainAvatar(props: MainAvatarProps) {
    /*
     * Компонент для аватара ползователя или команды (юнита, отдела).
     * */

    const theme = useTheme();

    if (!props.user) return null;

    return (
        <>
            <Tooltip key={props.user.id} title={props.user.name || ""}>
                <Avatar
                    children={getInitials(props.user.name || "")}
                    sx={{
                        bgcolor: stringToColor(props.user.name || ""),
                        color: theme.palette.getContrastText(stringToColor(props.user.name || "")),
                        width: props.size || 36,
                        height: props.size || 36,
                    }}
                />
            </Tooltip>
        </>
    );
}


function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

const getInitials = (fullname: string) => {
    const names: string[] = fullname.split(' ');
    let initials = ""
    for (let i = 0; i < names.length; i += 1) {
        initials += names[i][0].toUpperCase();
    }
    return initials;
}
